import fi from 'common-ui-components/src/vtj/static/localization_fi.json'
import sv from 'common-ui-components/src/vtj/static/localization_sv.json'
import en from 'common-ui-components/src/vtj/static/localization_en.json'
import translationInit from 'common-translations/src/vtj/translation-init'

const instance = translationInit({ fi, sv, en })
export default instance
